import SEO from "../../data/seo";
import FooterOne from "../../layout/footers/footer-one";
import HeaderTwo from "../../layout/headers/header-two";
import BreadCrumb from "../common/breadcrumb";
import ContactMain from "./contact";

const ContactUs = () => {
    return (
        <>
            <SEO pageTitle="Contact Us | Arclight Developers" />
            <HeaderTwo />
            <BreadCrumb title="Contact Us" innerTitle="Contact Us" />
            
            {/* The ContactMain component now holds both the form info and the map */}
            <ContactMain />
            
            <FooterOne />
        </>
    );
};

export default ContactUs;